exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../node_modules/css-loader/dist/cjs.js!../node_modules/bootstrap/dist/css/bootstrap.min.css"), "");
exports.i(require("-!../node_modules/css-loader/dist/cjs.js!../node_modules/font-awesome/css/font-awesome.min.css"), "");

// Module
exports.push([module.id, "html,body{height:100%}label input[type=checkbox],label input[type=radio]{margin-right:.3rem}", ""]);

